<template>
    <div>
        <SelecionarPrazoParcela v-if="m_tela === SELECIONAR_PRAZO_PARCELA" v-model="pedido" @nextPage="irParaSelecionarGrupo()" @prevPage="voltar()" />
        <SelecionarGrupo v-if="m_tela === SELECIONAR_GRUPO" v-model="pedido" @nextPage="avancar()" @prevPage="irParaPrazoParcela()" @reload="reload" />
    </div>
</template>

<script>
  import SelecionarPrazoParcela from './SelecionarPrazoParcela'
  import SelecionarGrupo from './SelecionarGrupo'

  export default {
    name: 'Grupo',
    components: { SelecionarPrazoParcela, SelecionarGrupo },
    props: { value: Object, tela: { type: String, validators: ['selecionar_prazo_parcela', 'selecionar_grupo', 'resumo'] } },
    data: () => ({
      pedido: {},
      m_tela: ''
    }),
    computed: {
      SELECIONAR_PRAZO_PARCELA: () => 'selecionar_prazo_parcela',
      SELECIONAR_GRUPO: () => 'selecionar_grupo'
    },
    watch: {
      tela (val) {
        this.m_tela = val
      },
      value (val) {
        this.pedido = val
      }
    },
    mounted () {
      this.pedido = { ...this.pedido, ...this.value }
      this.m_tela = this.tela || this.SELECIONAR_PRAZO_PARCELA
    },
    methods: {
      irParaPrazoParcela () {
        this.m_tela = this.SELECIONAR_PRAZO_PARCELA
      },
      irParaSelecionarGrupo () {
        this.m_tela = this.SELECIONAR_GRUPO
      },
      avancar () {
        this.$emit('input', { ...this.pedido })
        this.$emit('nextPage')
      },
      voltar () {
        this.$emit('input', this.pedido)
        this.$emit('prevPage')
      },
      reload (value) {
        this.$emit('reload', value)
      }
    }
  }
</script>

<style scoped>
</style>
